export const LetterBoxedBackground = '#0A0909'

export const calculateVideoAspectRatio = (
	video: HTMLVideoElement,
	canvas: HTMLCanvasElement,
) => {
	const videoAspectRatio = video.videoWidth / video.videoHeight
	const canvasAspectRatio = canvas.width / canvas.height

	let drawWidth, drawHeight, offsetX, offsetY

	if (videoAspectRatio > canvasAspectRatio) {
		drawWidth = canvas.width
		drawHeight = canvas.width / videoAspectRatio
		offsetX = 0
		offsetY = (canvas.height - drawHeight) / 2
	} else {
		drawHeight = canvas.height
		drawWidth = canvas.height * videoAspectRatio
		offsetX = (canvas.width - drawWidth) / 2
		offsetY = 0
	}

	return { drawWidth, drawHeight, offsetX, offsetY }
}

export const generateVideoThumbnail = async (
	videoFile: File,
): Promise<string> => {
	return new Promise((resolve, reject) => {
		const video = document.createElement('video')
		video.preload = 'metadata'
		video.src = URL.createObjectURL(videoFile)
		video.crossOrigin = 'anonymous'
		video.muted = true
		video.playsInline = true

		video.onloadedmetadata = async () => {
			try {
				const seekTo = video.duration ? video.duration / 2 : 0.5
				await video.play().catch(() => {})
				video.pause()
				video.currentTime = seekTo
			} catch {
				reject('Failed to seek video')
			}
		}

		video.onseeked = () => {
			try {
				const canvas = document.createElement('canvas')
				canvas.width = 312
				canvas.height = 312
				const ctx = canvas.getContext('2d')

				if (!ctx) throw new Error('Canvas context not available')

				const { drawWidth, drawHeight, offsetX, offsetY } =
					calculateVideoAspectRatio(video, canvas)

				ctx.fillStyle = LetterBoxedBackground
				ctx.fillRect(0, 0, canvas.width, canvas.height)
				ctx.drawImage(video, offsetX, offsetY, drawWidth, drawHeight)

				const thumbnailUrl = canvas.toDataURL('image/jpeg')
				URL.revokeObjectURL(video.src)
				resolve(thumbnailUrl)
			} catch {
				reject('Failed to draw thumbnail')
			}
		}

		video.onerror = () => {
			reject('Video failed to load')
		}
	})
}
